export enum AoaRequestType {
    GetProtocol = 51,
    SendString,
    Start,
    RegisterHid,
    UnregisterHid,
    SetHidReportDescriptor,
    SendHidEvent,
    SetAudioMode,
}
